exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-7ac1d640]{display:grid;text-align:left;grid-template-columns:133px -webkit-max-content 5px;grid-template-columns:133px max-content 5px}.metrics[data-v-7ac1d640]{padding-top:20px}.medium-badge[data-v-7ac1d640]{width:140px;height:140px;display:block;margin:auto}", ""]);

// exports
